// ── WhyEventDropSection ✦ — supportive context for parents ──────
//
// Sits at the bottom of the dashboard. Confidence · Communication
// · Teamwork · Real experience. No metrics, no aspirational
// pressure — just context.
import React from 'react';
import {
  Sparkle, ChatCircleDots, Users, ShieldCheck,
} from '@phosphor-icons/react';
import {
  TEXT, TEXT_SOFT, BLUE, VIOLET, GOLD, SAGE,
} from './palette';
import { Section } from './Section';

export const WhyEventDropSection = () => (
  <Section
    eyebrow="✦ Why EventDrop"
    title="Real-world confidence, one shift at a time"
    testid="parent-dashboard-why"
    accent={VIOLET}
  >
    <p style={{ margin: 0, color: TEXT_SOFT, fontSize: 13.5, lineHeight: 1.65 }}>
      EventDrop Crew helps young people build confidence through teamwork,
      communication, and paid opportunities at events with reviewed suppliers.
    </p>
    <div style={{
      marginTop: 14, display: 'grid', gap: 8,
      gridTemplateColumns: 'repeat(2, 1fr)',
    }}>
      {[
        { label: 'Confidence',      icon: Sparkle,        color: GOLD },
        { label: 'Communication',   icon: ChatCircleDots, color: BLUE },
        { label: 'Teamwork',        icon: Users,          color: VIOLET },
        { label: 'Real experience', icon: ShieldCheck,    color: SAGE },
      ].map((p) => (
        <div
          key={p.label}
          style={{
            padding: '11px 12px', borderRadius: 12,
            background: 'rgba(255,255,255,0.025)',
            border: `1px solid ${p.color}26`,
            display: 'flex', alignItems: 'center', gap: 10,
          }}
        >
          <p.icon size={15} weight="fill" color={p.color} />
          <span style={{ fontSize: 12.5, fontWeight: 700, color: TEXT }}>{p.label}</span>
        </div>
      ))}
    </div>
  </Section>
);
